import React, { Component } from 'react';
import { Card, CardBody, ButtonGroup, Button, Spinner } from 'reactstrap';
import ReactApexChart from 'react-apexcharts';
import { monthlyBookings } from '../../Endpoint/Admin';
import "./dashboard.scss";

class RevenueAnalyticsRoomBooking extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loaded: false,
            error: null,
            totalBookings: 0,
            series: [],
            options: {
                chart: {
                    type: 'bar',
                    toolbar: { show: false },
                    animations: {
                        enabled: true,
                        easing: 'easeinout',
                        speed: 800,
                    },
                    dropShadow: {
                        enabled: true,
                        top: 3,
                        left: 2,
                        blur: 4,
                        opacity: 0.15
                    }
                },
                plotOptions: {
                    bar: {
                        horizontal: false,
                        columnWidth: '55%',
                        borderRadius: 6,
                        distributed: false,
                        dataLabels: {
                            position: 'top'
                        }
                    },
                },
                dataLabels: {
                    enabled: true,
                    formatter: function (val) {
                        return val;
                    },
                    offsetY: -20,
                    style: {
                        fontSize: '12px',
                        fontWeight: 600,
                        colors: ['#505d69']
                    }
                },
                colors: ['#5664d2'],
                fill: {
                    type: 'solid',
                    opacity: 1
                },
                stroke: {
                    show: true,
                    width: 2,
                    colors: ['transparent']
                },
                xaxis: {
                    categories: [],
                    labels: {
                        style: {
                            colors: '#74788d',
                            fontSize: '12px',
                            fontWeight: 500
                        },
                        rotate: -45,
                        rotateAlways: false
                    },
                    axisBorder: { show: false },
                    axisTicks: { show: false }
                },
                yaxis: {
                    title: {
                        text: 'Bookings',
                        style: {
                            color: '#74788d',
                            fontSize: '12px',
                            fontWeight: 500
                        }
                    },
                    labels: {
                        style: {
                            colors: '#74788d',
                            fontSize: '12px'
                        }
                    }
                },
                grid: {
                    borderColor: '#f1f1f1',
                    strokeDashArray: 4,
                    padding: { top: 0, right: 0, bottom: 0, left: 10 }
                },
                tooltip: {
                    enabled: true,
                    y: {
                        formatter: function (val) {
                            return val + " bookings";
                        }
                    },
                    theme: 'light',
                    style: {
                        fontSize: '12px'
                    }
                },
                legend: { show: false }
            }
        };
        this.Bookings = this.Bookings.bind(this);
    }

    Bookings() {
        monthlyBookings().then((result) => {
            if (!result || !result.data || !result.data[0] || result.data[0].length === 0) {
                this.setState({
                    loaded: true,
                    error: 'No booking data available'
                });
                return;
            }

            const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
            let axis = [];
            let values = [];
            let _options = { ...this.state.options };
            let bookingData = result.data[0];
            let total = 0;

            // Sort by year and month
            bookingData.sort((a, b) => {
                if (a.year !== b.year) return a.year - b.year;
                return a.month - b.month;
            });

            // Get last 12 months only
            const last12 = bookingData.slice(-12);

            for (let index = 0; index < last12.length; index++) {
                const element = last12[index];
                axis.push(`${months[element.month - 1]} '${String(element.year).slice(-2)}`);
                values.push(element.count);
                total += element.count;
            }

            _options.xaxis.categories = axis;

            this.setState({
                series: [{
                    name: 'Room Bookings',
                    data: values
                }],
                options: _options,
                loaded: true,
                totalBookings: total,
                error: null
            });
        }).catch((err) => {
            console.log('Error fetching bookings:', err);
            this.setState({
                loaded: true,
                error: 'Failed to load booking data'
            });
        });
    }

    componentDidMount() {
        this.Bookings();
    }

    render() {
        return (
            <React.Fragment>
                <Card className="shadow-sm">
                    <CardBody>
                        <div className="d-flex justify-content-between align-items-center mb-4">
                            <div>
                                <h4 className="card-title mb-1">Room Bookings</h4>
                                {this.state.loaded && !this.state.error && (
                                    <p className="text-muted mb-0">
                                        Total: <strong className="text-primary">{this.state.totalBookings}</strong> bookings
                                    </p>
                                )}
                            </div>
                            <ButtonGroup className="mb-2">
                                <Button size="sm" color="primary" active type="button">
                                    <i className="ri-bar-chart-2-line mr-1"></i> Monthly
                                </Button>
                            </ButtonGroup>
                        </div>

                        <div style={{ minHeight: '300px' }}>
                            {!this.state.loaded ? (
                                <div className="d-flex justify-content-center align-items-center" style={{ height: '280px' }}>
                                    <Spinner color="primary" />
                                    <span className="ml-2">Loading chart...</span>
                                </div>
                            ) : this.state.error ? (
                                <div className="d-flex flex-column justify-content-center align-items-center" style={{ height: '280px' }}>
                                    <i className="ri-bar-chart-box-line text-muted" style={{ fontSize: '48px' }}></i>
                                    <p className="text-muted mt-2">{this.state.error}</p>
                                    <Button color="light" size="sm" onClick={this.Bookings}>
                                        <i className="ri-refresh-line mr-1"></i> Retry
                                    </Button>
                                </div>
                            ) : (
                                <div id="room-booking-chart" className="apex-charts" dir="ltr">
                                    <ReactApexChart
                                        options={this.state.options}
                                        series={this.state.series}
                                        type="bar"
                                        height="300"
                                    />
                                </div>
                            )}
                        </div>
                    </CardBody>
                </Card>
            </React.Fragment>
        );
    }
}

export default RevenueAnalyticsRoomBooking;
